import { FC } from "react";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly label: string;
  readonly onSelect: (label: string) => void;
  readonly disabled?: boolean;
}

/* A clickable prompt suggestion, shared by the welcome presets and assistant follow-ups. */
export const SuggestionChip: FC<Props> = ({ styles, label, onSelect, disabled = false }) => (
  <button
    type="button"
    className={styles.SuggestionChip}
    disabled={disabled}
    onClick={() => onSelect(label)}
  >
    {label}
  </button>
);
